import { MWST_RATE } from '../config/serviceConfig';

export function toDisplayPrice(net: number, showGross: boolean): number {
  return showGross ? net * (1 + MWST_RATE) : net;
}

export function formatDisplayPrice(
  net: number,
  showGross: boolean,
  digits = 2,
): string {
  return toDisplayPrice(net, showGross).toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/** Ganze Euro kompakt, Centpreise mit zwei Nachkommastellen. */
export function formatLinePrice(net: number, showGross: boolean): string {
  const cents = Math.round(toDisplayPrice(net, showGross) * 100);
  return formatDisplayPrice(net, showGross, cents % 100 === 0 ? 0 : 2);
}

export function taxNote(showGross: boolean): string {
  return showGross ? 'inkl. 19 % MwSt.' : 'zzgl. 19 % MwSt.';
}

const STORAGE_KEY = 'skyvision-tax-mode';

export function readShowGross(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== 'net';
  } catch {
    return true;
  }
}

export function writeShowGross(showGross: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, showGross ? 'gross' : 'net');
  } catch {
    /* private mode */
  }
}
